import * as z from "zod/v4";

export const speechToText = {
  name: "speechToText" as const,

  // Input schema: we receive the audio as base64 encoded data
  input: z.object({
    // Audio data encoded as base64
    audioData: z.string().min(1, "Audio data is required"),
    // Optional language code (defaults to en-US)
    languageCode: z.string().optional(),
    // Optional encoding format (defaults to WEBM_OPUS)
  }),

  // Output schema: return the transcribed text with metadata
  output: z.object({
    // The transcribed text
    text: z.string(),
  }),
};
